// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".forget[data-v-395fa938]{color:#3468fa;font-size:14px;display:block;float:right;margin-top:10px;cursor:pointer}.login-account-style .login-other-group[data-v-395fa938]{margin-top:30px}.login-account-style[data-v-395fa938]{padding-bottom:25px}", ""]);
// Exports
module.exports = exports;
